import { array, concat } from '@ember/helper';
import Component from '@glimmer/component';

import joinClasses from 'webapp/helpers/join-classes';
import BlockContentCommonComparesComponent from 'webapp/components/block/content/common/compares';
import type { CompareDisplayData } from 'webapp/components/block/content/common/compares';
import BlockContentCommonValueComponent from 'webapp/components/block/content/common/value';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type DChartPrimaryPoint from 'webapp/d-chart/point/primary-point';

interface Args {
	label: string;
	isLoading: boolean;
	valuePoint?: DChartPrimaryPoint | null;
	dateText?: string;
	icon?: IconName;
	size?: 'primary';
	valueClass?: string;
	labelColorClass?: string | number;
	comparePoints?: CompareDisplayData[];
	skipCompareText?: boolean;
	skipCompareValue?: boolean;
}

export default class MetricDetailsTopDatapointsDatapointCardComponent extends Component<{
	Args: Args;
}> {
	// explicit nullish check so a colorIndex of 0 (a valid Highcharts color)
	// still renders the class. A truthy check would drop it.
	get labelColorClass(): string | null {
		const value = this.args.labelColorClass;
		return value === undefined || value === null ? null : `highcharts-color-${value}`;
	}

	get showCompareText(): boolean {
		return !this.args.skipCompareText;
	}

	get showCompareValue(): boolean {
		return !this.args.skipCompareValue;
	}

	<template>
		<div
			class={{joinClasses
				(array "top-datapoints__card" (if @size (concat "top-datapoints__card--" @size)))
			}}
		>
			<div class={{joinClasses (array "top-datapoints__card-label" this.labelColorClass)}}>
				{{#if @icon}}
					<CommonUiIconComponent @name={{@icon}} @size="sm" />
				{{/if}}
				<span class="top-datapoints__card-label-text">{{@label}}</span>
				{{#if @dateText}}
					<span class="top-datapoints__card-label-date">({{@dateText}})</span>
				{{/if}}
			</div>
			{{#if @isLoading}}
				<div class="top-datapoints__card-skeleton"></div>
			{{else}}
				<div
					class={{joinClasses
						(array
							"top-datapoints__card-value"
							(if @valueClass (concat "top-datapoints__card-value--" @valueClass))
						)
					}}
				>
					{{#if @valuePoint}}
						<BlockContentCommonValueComponent @model={{@valuePoint}} />
					{{else}}
						-
					{{/if}}
				</div>
				<div class="top-datapoints__card-compare">
					{{#if @comparePoints}}
						<BlockContentCommonComparesComponent
							@model={{@comparePoints}}
							@showCompareText={{this.showCompareText}}
							@showCompareValue={{this.showCompareValue}}
						/>
					{{/if}}
				</div>
			{{/if}}
		</div>
	</template>
}
